import type { AdminUser } from './api';

export function listTransferableOwnerUsers(
  users: AdminUser[],
  currentOwnerId: string | null
): AdminUser[] {
  return users.filter(user => user.active && user.id !== currentOwnerId);
}
